import React from 'react';
import PropTypes from 'prop-types';
import FloatingLabel from 'Components/UI/BehavioralFormElement/LabelDecorator/Floating';
import TextInput from 'Components/UI/BehavioralFormElement/NormalizedInput/Text';
import { noop } from 'Helpers/PropTypes';

const TextInputAlias = ({
  className, label, test, ...props
}) => (
  <FloatingLabel className={`Input ${className}`} label={label}>
    <TextInput test={test} {...props} />
  </FloatingLabel>
);

TextInputAlias.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  test: PropTypes.string,
  max: PropTypes.number,
  readOnly: PropTypes.bool,
};

TextInputAlias.defaultProps = {
  className: '',
  label: '',
  onKeyDown: noop,
  placeholder: '',
  value: '',
  test: '',
  max: 100,
  readOnly: false,
};

export default TextInputAlias;
